export const COLLECTION_FILTERING_PROPERTIES = [
  {
    propertyLabel: 'Collection ID',
    key: 'collectionId',
    groupValuesLabel: 'Collection ID',
    operators: [':', '!:', '=', '!=', '^'],
  },
  {
    propertyLabel: 'Title',
    key: 'title',
    groupValuesLabel: 'Title values',
    operators: [':', '!:', '=', '!=', '^'],
  },
  {
    propertyLabel: 'Owners',
    key: 'ownerNamesString',
    groupValuesLabel: 'Owner values',
    operators: [':', '!:', '=', '!=', '^'],
  },
  {
    propertyLabel: 'Who can view',
    key: 'audience',
    groupValuesLabel: 'Audience values',
    operators: ['='],
  },
  {
    propertyLabel: 'Collection published',
    key: 'isPublished',
    groupValuesLabel: 'Is collection published',
    operators: ['='],
  },
  {
    propertyLabel: 'Official offering',
    key: 'isOfficial',
    groupValuesLabel: 'Is official offering',
    operators: ['='],
  },
];
